import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faCalendarCheck, faFileCircleCheck, faGavel } from '@fortawesome/free-solid-svg-icons';
import DS from "./DS";

const Acasa = () => {
  return (
    <>
      <div className="home-page">
        <Helmet>
          <title>Avukat Ankara | Ali Arda Gül Hukuk Bürosu - Aile, Ceza ve Ticaret Hukuku</title>
          <meta name="description" content="Ankara merkezli Ali Arda Gül Hukuk Bürosu, aile hukuku, ticaret hukuku, ceza hukuku ve daha birçok alanda güvenilir avukatlık hizmetleri sunar. Hızlı ve etkin çözümler için hemen iletişime geçin." />
          <meta name="keywords" content="Avukat Ankara, Aile Hukuku Avukatı, Ticaret Hukuku, Ceza Hukuku, İcra Hukuku, Miras Hukuku, Hukuki Danışmanlık, Ali Arda Gül, Boşanma Avukatı Ankara, Avukatlık Bürosu Ankara" />
          <meta name="author" content="Ali Arda Gül Hukuk Bürosu" />
          
          {/* Open Graph Tags */}
          <meta property="og:title" content="Avukat Ankara | Ali Arda Gül Hukuk Bürosu" />
          <meta property="og:description" content="Aile, ticaret ve ceza hukuku alanlarında uzmanlaşmış Ankara merkezli hukuk büromuzdan profesyonel destek alın." />
          <meta property="og:image" content="https://aliardagul.av.tr/assets/law-justice.webp" />
          <meta property="og:url" content="https://aliardagul.av.tr" />
          <meta property="og:type" content="website" />
          <meta property="og:locale" content="tr_TR" />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Avukat Ankara | Ali Arda Gül Hukuk Bürosu" />
          <meta name="twitter:description" content="Ali Arda Gül ile hukuki sorunlarınıza çözüm bulun. Aile, ticaret ve ceza hukukunda uzmanlık." />
          <meta name="twitter:image" content="https://aliardagul.av.tr/assets/law-justice.webp" />

          {/* Canonical URL */}
          <link rel="canonical" href="https://aliardagul.av.tr/" />

          {/* Structured Data (JSON-LD) */}
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "LegalService",
                "name": "Ali Arda Gül Hukuk Bürosu",
                "url": "https://aliardagul.av.tr",
                "logo": "https://aliardagul.av.tr/assets/logo.webp",
                "image": "https://aliardagul.av.tr/assets/law-justice.webp",
                "description": "Ankara'da aile, ticaret ve ceza hukuku başta olmak üzere geniş bir alanda profesyonel avukatlık hizmeti sunuyoruz.",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Ankara",
                  "addressCountry": "TR"
                },
                "contactPoint": {
                  "@type": "ContactPoint",
                  "telephone": "+90 555 555 5555",
                  "contactType": "Customer Service"
                }
              }
            `}
          </script>
        </Helmet>
       
        {/* HERO=========== */}
        <div className="container-fluid">
          <div className="row">
            <div className="hero-section">
              <div className="hero-overlay"></div>
              <div className="text-container d-flex flex-column justify-content-start align-items-start pt-6 slide">
                <div className="text-1 fs-2 pb-3">Ali Arda Gül</div>
                <div className="text-2 fs-4">
              
                  <span className="fw-bold">
                     Avukat{" "}
                  </span>
                </div>
                <div className="text-3 fst-italic fw-light">
                "Her gerçek ve tüzel kişinin, diğer kişiler ve devlet nezdinde adil bir şekilde temsil edilme hakkına sahip olduğuna inanıyoruz. Bu çerçevede, hukuki ilişkilerinizin düzenlenmesi ve tarafı olduğunuz uyuşmazlıkların etkin ve adil bir biçimde çözüme kavuşturulması amacıyla hizmet sunmaktayız."
                 <p>Ali Arda Gül </p> 
                </div>
              </div>
              {/* horizontal buttons */}
              <div className="horizontal-btn d-none d-md-flex justify-content-center  align-items-end w-100 h-100">
                <div className=" col flex-grow-1">
                  <Link to="/calendar">
                    <button
                      id="horizontal1"
                      className="btn btn-outline-dark btn-lg  type-button p-4 w-100 fw-bold"
                      aria-label="Programare"
                    >
                      <span className="p-3">
                        <FontAwesomeIcon icon={faCalendarCheck} size="1x" />
                      </span>
                      Randevu
                    </button>
                  </Link>
                </div>
                <div className="col flex-grow-1">
                  <Link to="/iletisim">
                    <button
                      className="btn btn-lg btn-outline-dark type-button p-4 w-100 fw-bold"
                      aria-label="Cere o evaluare"
                    >
                      <span className="p-3">
                        <FontAwesomeIcon icon={faFileCircleCheck} size="1x" />
                      </span>
                      Tavsiye İsteyin
                    </button>
                  </Link>
                </div>
                <div className="col flex-grow-1">
                  <Link to="/Bilgi">
                    <button
                      className="btn btn-lg btn-outline-dark type-button p-4 w-100 fw-bold"
                      aria-label="Onorarii"
                    >
                      <span className="p-3">
                        <FontAwesomeIcon icon={faBook} size="1x" />
                      </span>
                      Yararlı Bilgiler
                    </button>
                  </Link>
                </div>
              </div>
            </div>
            {/* small screens buttons*/}
            <div className="mobile-btn d-md-none d-flex justify-content-between pt-2">
              <Link to="/calendar">
                <button
                  id="small"
                  className="btn btn-outline-dark type-button p-2 mb-1 btn-md me-1"
                  aria-label="Programare"
                >
                  <span className="p-3">
                    <FontAwesomeIcon icon={faCalendarCheck} size="2x" />
                  </span>
                  Randevu
                </button>
              </Link>
              <Link to="/iletisim">
                <button
                  className="btn btn-outline-dark type-button p-2 mb-1 btn-md me-1"
                  aria-label="Cere o evaluare"
                >
                  <span className="p-3">
                    <FontAwesomeIcon icon={faFileCircleCheck} size="2x" />
                  </span>
                  Tavsiye Al
                </button>
              </Link>
              <Link to="/Bilgi">
                <button
                  className="btn btn-outline-dark type-button p-2 mb-1 btn-md me-1"
                  aria-label="Onorarii"
                >
                  <span className="p-3">
                    <FontAwesomeIcon icon={faBook} size="2x" />
                  </span>
                  Kılavuz
                </button>
              </Link>
            </div>
          </div>
        </div>

       

        <section className="card py-5 px-3 border-0">
          <div className="row">
            <div className="col-lg-7">
              <div className="card-body">
                <h3 className="guide-text mb-4">GİRİŞ</h3>
                <h5 className="lh-base text-center pb-4">
               <p>Hoş Geldiniz!</p> 

               Hukuki uyuşmazlıklarınızın çözümünde güvenilir bir çözüm ortağı olarak yanınızdayız.          
               <p>Avukatlık büromuz, gerçek ve tüzel kişilere hızlı ve etkili hukuki çözümler sunmakta, haklarınızı korumak için en güncel bilgi ve deneyimi kullanarak hizmet vermektedir.</p> 

           
           <p> Bizimle iletişime geçerek hukuki destek alabilir ve hizmetlerimizden yararlanabilirsiniz.</p>
                                                                           
                </h5>

                <p className="text-separator fw-normal">
                 
                  <br />
                  <span className="ms-4"></span>
                  <span></span>
                </p>
              </div>
            </div>

            <div className="col-lg-5 d-flex align-items-center justify-content-center">
              <div>
                <img
                  src="/assets/law-justice.webp"
                  className="intro-img img-fluid d-block rounded-2"
                  alt=" a gavel, scales of justice, and law books"
                  style={{ maxHeight: "300px" }}
                />
              </div>
            </div>
          </div>
        </section>

        
        <div className="">
          <div className="row">
            <div className="col">
              <div className="services-section ">
                <div className="services-overlay "></div>

                <div className="services-content container mt-3">
                  <h3 className=" guide-text"> HİZMETLER</h3>

                  <h5 className="lh-base text-center pb-3">
                   Faaliyet Alanları 
                  </h5>
                  <div className="row mt-3 gx-3 flex-column flex-md-row ">
                    <div className="col-md-6">
                      <h5 className="color text-center pb-4">
                      Davalar ve Uyuşmazlıklar
                      </h5>
                      <div className="d-flex align-items-center">
                        <img
                          src="/assets/barou.jpeg"
                          className="barou img-fluid mx-auto d-block rounded-2"
                          alt=""
                          width="250px"
                          height="400"
                        />
                      </div>
                      
                      
                       <p className="pt-4 px-2"> Hukuk büromuz, Ticaret, Aile, Miras, Gayrimenkul, Tüketici, İcra, Ceza ve İdare-Vergi Hukuku gibi çeşitli alanlarda profesyonel avukatlık hizmeti sunmaktadır.</p>
                      
                      <div className="py-3 text-center">
                        <Link to="/Hizmetler">
                          <button
                            type="button"
                            className="btn btn-outline-dark mb-4"
                            aria-label="Afla mai multe"
                          >
                            Daha Fazlası
                          </button>
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <h5 className="color text-center pb-4">
                        Danışmanlık ve Önleyici Hukuk
                      </h5>
                      <div className="d-flex align-items-center">
                        <img
                          src="/assets/unpir.jpeg"
                          className="unpir img-fluid mx-auto d-block rounded-2"
                          alt="sigla unpir"
                          width="150"
                          height="150"
                        />
                      </div>
                      <p className="pt-4 px-2">
                      Gerçek ve tüzel kişiler için hukuki tavsiyeler sunma ve  hukuki sorunların ortaya çıkmasını engellemeye yönelik faaliyetlerimizi içerir.
                      </p>
                      <div className="py-3 text-center">
                     
                        <Link to="/Danismanlik">
                          <button
                            type="button"
                            className="btn btn-outline-dark mb-4"
                            aria-label="Afla mai multe"
                          >
                          
                           Daha Fazlası
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

       

        <section className="card py-4 px-3 border-0">
          <div className="row">
            <div className="col-lg-7">
              <div className="card-body">
                <h3 className="guide-text mb-4">HAKKIMIZDA</h3>
                <h5 className="lh-base text-center pb-4">
                </h5>

                <p className="text-separator fw-normal">
                Ankara'da doğan  Ali Arda Gül, Mehmet Emin Resulzade Anadolu Lisesi'nden mezun olduktan sonra Kırıkkale Üniversitesi Hukuk Fakültesi'nde eğitimine devam etmiştir. "Türkiye'de Yargı Etiği" başlıklı mezuniyet teziyle fakülteden mezun olmuş ve Ankara Barosu'nda stajını tamamlamıştır.

              
                  <br></br>
                  <span className="ms-4"></span>Kısa bir süre serbest avukat olarak çalışmasının ardından askerlik hizmetini "Yedek Subay" olarak yerine getirmiştir. Bu süreçte, Ankara Jandarma Genel Komutanlığı Hukuk Hizmetleri Başkanlığı'nda "Disiplin Kurullarında Hukuk Uzmanı" ve "Mevzuat İnceleme ve Takip İşleri Uzmanı" olarak görev yapmıştır.
                  <br></br> <span className="ms-4"></span>Askerlik sonrasında Ticaret Hukuku alanında yüksek lisans eğitimine başlayan Ali Arda Gül, ileri düzey İngilizce bilmektedir ve şu anda Ankara'da serbest avukat olarak mesleğini sürdürmektedir.
                </p>
              </div>
            </div>
            <div className="col-lg-5 d-flex align-items-center justify-content-center">
              <div>
                <img
                  src="/assets/ardaaaaa.jpeg"
                  className="intro-img img-fluid d-block rounded-2"
                  alt="two persons at a desk"
                  style={{ maxHeight: "300px" }}
                />
              </div>
            </div>
          </div>
        </section>

       
        <section className="recommendation p-3 bg-image m-3 px-0">
          <h3 className="guide-text ">
          UZMANLIKLARIMIZ</h3>
          <div className="container d-flex flex-column justify-content-center align-items-center">
         
          </div>
          <div className="row mt-4 flex-column flex-md-row mb-3">
            <div className="col col-md-7 order-md-2">
              <ul className="my-list">
                <li>Her türlü sözleşmenin hazırlanması</li>
                <li>
                7068 sayılı Kanun uyarınca verilen disiplin cezalarının iptali
                </li>
                <li> 
                Kira Hukukundan Kaynaklı Uyuşmazlıklar</li>
                <li> Araç Değer Kaybı Başvuruları</li>
                <li>  Anlaşmalı ve Çekişmeli Boşanma Davaları </li>
                <li> Vergi cezalarının iptali</li>
                <li> Ticaret Hukuku </li>
              
                <li> Miras Hukuku </li>
                <li> 
                Vesayet Başvuruları </li>
                <li>
                  {" "}
                  Aile Hukuku 
                </li>
                <li> Ceza Hukuku </li>
                
              </ul>
            </div>
            <div className=" col col-md-5 order-md-2 mt-5">
              <div className="square container d-flex flex-column justify-content-center align-items-center py-5 w-50 border border-white border-4 fw-bold">
                <div>
                  <FontAwesomeIcon icon={faGavel} size="2x" />
                </div>
                <div>6+</div>
                <div>Yılların Tecrübesi</div>
              </div>
            </div>
           
          </div>
        </section>
        <DS/>
      </div>
    </>
  );
};

export default Acasa;
